module.exports = __webpack_public_path__ + "img/mini-Code-vestimentaire-web.fe4b9aed.jpeg";